/**
 * What this browser keeps (J11 cookie choice). Room Map Pro sets no tracking or advertising cookies. Sign-in and
 * short-lived hand-offs are essential and always on; two things are optional and can be turned off here:
 * display preferences (theme, motion, collapsed navigation, list density) and the offline copy of the check-in
 * list. Turning either off also deletes what was already kept.
 */
export type StorageChoice = { preferences: boolean; offline: boolean; analytics: boolean };
const KEY = 'rmp2.storage-choice';
export const PREFERENCE_KEYS = ['rmp2.theme', 'rmp2.motion', 'rmp2.nav.collapsed', 'rmp2.guests.density', 'rmp2.getting-started.dismissed', 'rmp2.properties.pinned', 'rmp2.events.recent', 'rmp2.board.lastRoom', 'rmp2.plan.scan', 'rmp2.nights.showRates', 'rmp2.prospects.view'] as const;

export function getStorageChoice(): StorageChoice {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) ?? 'null') as Partial<StorageChoice> | null;
    // analytics is opt-in: only an explicit yes turns it on
    return { preferences: v?.preferences !== false, offline: v?.offline !== false, analytics: v?.analytics === true };
  } catch {
    return { preferences: true, offline: true, analytics: false };
  }
}

export function setStorageChoice(next: StorageChoice): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
    if (!next.preferences) for (const k of PREFERENCE_KEYS) localStorage.removeItem(k);
  } catch { /* storage unavailable: nothing is kept anyway */ }
  if (!next.offline && typeof indexedDB !== 'undefined') indexedDB.deleteDatabase('booklyn_offline');
}

/** Save an optional display preference — only when the person allows it. */
export function savePreference(key: (typeof PREFERENCE_KEYS)[number], value: string): void {
  if (!getStorageChoice().preferences) return;
  try { localStorage.setItem(key, value); } catch { /* private mode: not kept */ }
}
